import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { errMsg } from "../api";
import { Lock, ArrowLeft } from "lucide-react";

export default function AdminLogin() {
    const { adminLogin } = useAuth();
    const navigate = useNavigate();
    const [u, setU] = useState("admin");
    const [p, setP] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        try {
            await adminLogin(u, p);
            navigate("/admin");
        } catch (e) {
            setErr(errMsg(e) || "Invalid credentials");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-shell flex items-center justify-center px-5" data-testid="admin-login-page">
            <div className="admin-card w-full max-w-md p-10">
                <div className="flex items-center justify-center mb-6">
                    <div className="w-12 h-12 rounded-full bg-[var(--gold)] grid place-items-center">
                        <Lock size={20} color="#2a221d" />
                    </div>
                </div>
                <h1 className="font-serif text-3xl text-center text-[#e9e2d3]">UCare Essentials</h1>
                <div className="text-center text-[12px] uppercase tracking-[0.22em] text-[#b8b0a0] mt-1 mb-8">Admin Panel</div>
                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <label className="text-[11px] uppercase tracking-[0.18em] text-[#b8b0a0] block mb-2">Username</label>
                        <input className="admin-input" value={u} onChange={(e) => setU(e.target.value)} required data-testid="admin-username" />
                    </div>
                    <div>
                        <label className="text-[11px] uppercase tracking-[0.18em] text-[#b8b0a0] block mb-2">Password</label>
                        <input className="admin-input" type="password" value={p} onChange={(e) => setP(e.target.value)} required data-testid="admin-password" />
                    </div>
                    {err && <div className="text-[var(--gold)] text-[13px]" data-testid="admin-login-error">❌ {err}. Try: admin / admin123</div>}
                    <button className="w-full bg-[var(--gold)] text-[#2a221d] py-3 rounded-md font-semibold hover:opacity-90 transition" disabled={loading} data-testid="admin-login-submit">
                        {loading ? "Signing in…" : "Sign In →"}
                    </button>
                </form>
                <a href="/" className="flex items-center justify-center gap-1.5 text-[13px] text-[#b8b0a0] hover:text-[#e9e2d3] mt-6">
                    <ArrowLeft size={14} /> Back to Store
                </a>
                <div className="text-center text-[11px] text-[#7a7264] mt-4">Default: admin / admin123</div>
            </div>
        </div>
    );
}
